<template>
  <Popup
    position="bottom"
    v-model:show="showModal"
    @click-close-icon="onClickCloseIcon"
    @click-overlay="onClickCloseIcon"
  >
    <div class="reveiw">
      <div class="title">{{ evaluationInfo.satisfactionRatingGuide }}</div>
      <div class="reivew-rate">
        <div
          v-for="(item, n) in list"
          :key="n"
          class="rate-item"
          @click="onSelectRate(item.level)"
        >
          <img
            :src="
              evaluationLevel !== item.level ? item.disabledSrc : item.activeSrc
            "
            :alt="item.name"
          />
          <span
            class="rate-type-title"
            :class="evaluationLevel === item.level ? 'font-bold' : ''"
            >{{ item.evaluationTag }}</span
          >
        </div>
      </div>
      <div class="title">{{ evaluationInfo.evaluationGuideContent }}</div>
      <div class="tags">
        <!-- <van-tag
          v-for="tag in evaluationInfo.evaluationTags"
          class="tag"
          round
          size="large"
          :color="evaluationSelectedtag === tag ? '#fdbb2b' : '#333'"
          plain
          @click="onSelectTag(tag)"
          >{{ tag }}</van-tag
        > -->
        <RadioGroup v-model="evaluationSelectedtag">
          <Radio
            v-for="(m, n) in evaluationInfo.evaluationTags"
            :key="n"
            :name="m.evaluationTag"
            :checked-color="m.textColor"
          >
            <span :style="{ color: m.textColor }">{{ m.evaluationTag }}</span>
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? m.iconSel : m.iconUnsel"
              />
            </template>
          </Radio>
        </RadioGroup>
      </div>
      <Button
        round
        type="primary"
        size="large"
        :disabled="!evaluationLevel || !evaluationSelectedtag"
        @click="doSubmit"
        >{{ $t(`message.submit`) }}</Button
      >
    </div>
  </Popup>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { showFailToast, Popup, RadioGroup, Radio, Button } from "vant";
import { submitReview, fetchEvaluationConfig } from "@/api/msg.js";
import very_dissatisfied_disabled from "@/assets/images/im/very_dissatisfied_disabled.png";
import very_dissatisfied from "@/assets/images/im/very_dissatisfied.png";
import dissatisfied from "@/assets/images/im/dissatisfied.png";
import dissatisfied_disabled from "@/assets/images/im/dissatisfied_disabled.png";
import generally from "@/assets/images/im/generally.png";
import generally_disabled from "@/assets/images/im/generally2_disabled.png";
import very_satisfied from "@/assets/images/im/very_satisfied.png";
import very_satisfied_disabled from "@/assets/images/im/very_satisfied2_disabled.png";
import satisfied from "@/assets/images/im/satisfied.png";
import satisfied_disabled from "@/assets/images/im/satisfied_disabled.png";

const props = defineProps({
  visible: {
    default: false,
    type: Boolean,
  },
  reviewMessage: {
    default: () => ({}),
    type: Object,
  },
});

const evaluationInfo = ref({});
const evaluationLevel = ref(0);
const evaluationSelectedtag = ref("");

const list = ref([
  {
    level: 1,
    activeSrc: very_dissatisfied,
    disabledSrc: very_dissatisfied_disabled,
  },
  { level: 2, activeSrc: dissatisfied, disabledSrc: dissatisfied_disabled },
  { level: 3, activeSrc: generally, disabledSrc: generally_disabled },
  { level: 4, activeSrc: satisfied, disabledSrc: satisfied_disabled },
  { level: 5, activeSrc: very_satisfied, disabledSrc: very_satisfied_disabled },
]);

watch(
  () => props.visible,
  (newVal) => {
    console.log("newVal", newVal);
    if (newVal) {
      onView();
    }
  },
);

const emits = defineEmits(["toggleView"]);

const showModal = computed(() => props.visible);

const onClickCloseIcon = () => {
  console.log("close");
  emits("toggleView");
};

const onView = async () => {
  const params = { messageId: props.reviewMessage._id };
  const res = await fetchEvaluationConfig(params);
  if (res.data) {
    const tagList = (res.data || {}).levelEvaluationExtList || [];
    const newList = list.value.map((item) => {
      const [selectedTag] = tagList.filter((tag) => tag.level === item.level);
      return Object.assign(item, selectedTag);
    });
    list.value = newList;
    evaluationInfo.value = res.data || {};
  } else {
    showFailToast(res.rtn_msg);
    onClickCloseIcon();
  }
};

const doSubmit = async () => {
  try {
    const [tag] = list.value.filter(
      (tagItem) => tagItem.level === evaluationLevel.value,
    );
    const params = {
      messageId: props?.reviewMessage?._id,
      evaluationLevel: tag.level,
      evaluationTag: evaluationSelectedtag.value,
    };
    console.log("提交", params);
    submitReview(params).then((res) => {
      if (res.data) {
        onClickCloseIcon();
      } else {
        showFailToast(res.rtn_msg);
      }
    });
  } catch (e) {
    showFailToast(e.message);
  }
};

const onSelectRate = async (level) => {
  evaluationLevel.value = level;
};

const onSelectTag = (tag) => {
  evaluationSelectedtag.value = tag;
};
</script>
<style scoped lang="scss">
.reveiw {
  padding: 10px;
  color: #333;
  .rate {
    display: flex;
  }
  .reivew-rate {
    display: flex;
    margin-bottom: 10px;
    .rate-item {
      display: inline-flex;
      flex-flow: column nowrap;
      align-items: center;
      text-align: center;
      width: 64px;
      margin: 0 6px;
      line-height: 12px;
    }
    .rate-type-title {
      margin-top: 8px;
      display: inline-flex;
      height: 24px;
      align-items: center;
    }
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
  }
  .tags {
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    .tag {
      margin-right: 10px;
    }
  }
}
</style>
